// Single income source for the P&L. Runs the validated engine + QB-actuals
// reconciliation and returns reconciled monthly INCOME shaped for the P&L, for the
// global book and each division. This replaces the old base-projection plus
// won-deals overlay: the income here is COMPLETE (clients + not-yet-client
// Closed-Won), so no overlay is added on top.

import { mapClientToEngagements } from './mapClientToEngagements.mjs';
import { reconcileYear } from './reconcileActuals.mjs';

const MK = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
const CAT_DIVISION = {
  subscription_fees: 'bwm', investment_management: 'bwm', tax_planning: 'bwm',
  tax_preparation: 'bts', bookkeeping: 'bts', cao: 'bts', commissions: 'bia',
};
// QB income accounts we get actuals for (bookkeeping and cao have no QB account).
const QB_CATS = ['subscription_fees', 'investment_management', 'tax_planning', 'tax_preparation', 'commissions'];

// Per-category QB actuals + closed-month cutoff, from firm_settings.plClassActuals.
export function qbActualsFromClassActuals(classActuals) {
  const qb = {};
  for (const c of QB_CATS) qb[c] = new Array(12).fill(0);
  let cutoff = 0;
  for (let m = 0; m < 12; m++) {
    let any = false;
    for (const cls of ['bwm', 'bts', 'bia']) {
      const inc = classActuals?.[cls]?.months?.[MK[m]]?.income;
      if (!inc) continue;
      for (const c of QB_CATS) { const v = Number(inc[c]) || 0; if (v) { qb[c][m] += v; any = true; } }
    }
    if (any) cutoff = m + 1;
  }
  return { qb, cutoff };
}

// { global: {months:{mk:{income}}}, byClass: {bwm,bts,bia:{months:{mk:{income}}}}, cutoff }
export function buildPLIncome(clients, classActuals, year) {
  const engagements = (clients || []).flatMap(mapClientToEngagements);
  const { qb, cutoff } = qbActualsFromClassActuals(classActuals);
  const { byCategory } = reconcileYear(engagements, qb, cutoff, year);

  const global = { months: {} };
  const byClass = { bwm: { months: {} }, bts: { months: {} }, bia: { months: {} } };
  for (let m = 0; m < 12; m++) {
    const g = {};
    const perClass = { bwm: {}, bts: {}, bia: {} };
    for (const cat of Object.keys(byCategory)) {
      const v = Math.round((byCategory[cat][m] || 0) * 100) / 100;
      g[cat] = v;
      perClass[CAT_DIVISION[cat] || 'bts'][cat] = v;
    }
    global.months[MK[m]] = { income: g };
    for (const cls of ['bwm', 'bts', 'bia']) byClass[cls].months[MK[m]] = { income: perClass[cls] };
  }
  return { global, byClass, cutoff };
}
